import { BonusGameBonusTypes } from './types/bonusGameTypes';

const bonusGameTypeName = {
  [BonusGameBonusTypes.money]: 'Гроші',
  [BonusGameBonusTypes.promo]: 'Промокод'
};

export default bonusGameTypeName;
